// Webpack entrypoint — bundles fonts, styles, and app JS into a single "app" chunk.

// Self-hosted fonts (no external CDN).
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import '@fontsource/jetbrains-mono/600.css';

import './resources/scss/app.scss';
import './resources/js/app.js';
